import { useFirebaseConfig } from "./remote-config";

export default function useAllowSitewideSearch() {
  const firebaseConfig = useFirebaseConfig()
  const allowSitewideSearch = firebaseConfig.config.allowSitewideSearch?.asBoolean() ?? true

  return allowSitewideSearch
}